import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing tokens on mount
    const userToken = localStorage.getItem('userToken');
    const userData = localStorage.getItem('userData');
    const adminToken = localStorage.getItem('adminToken');
    const adminData = localStorage.getItem('adminData');

    if (userToken && userData) {
      setUser(JSON.parse(userData));
    }

    if (adminToken && adminData) {
      setAdmin(JSON.parse(adminData));
    }

    setLoading(false);
  }, []);

  const loginUser = (token, userData) => {
    localStorage.setItem('userToken', token);
    localStorage.setItem('userData', JSON.stringify(userData));
    setUser(userData);
  };

  const logoutUser = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userData');
    setUser(null);
  };

  const loginAdmin = (token, adminData) => {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminData', JSON.stringify(adminData));
    setAdmin(adminData);
  };

  const logoutAdmin = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    setAdmin(null);
  };

  const updateUser = (userData) => {
    localStorage.setItem('userData', JSON.stringify(userData));
    setUser(userData);
  };

  const isUserAuthenticated = () => {
    return !!localStorage.getItem('userToken');
  };

  const isAdminAuthenticated = () => {
    return !!localStorage.getItem('adminToken');
  };

  const getUserToken = () => {
    return localStorage.getItem('userToken');
  };

  const getAdminToken = () => {
    return localStorage.getItem('adminToken');
  };

  return (
    <AuthContext.Provider value={{
      user,
      admin,
      loading,
      loginUser,
      logoutUser,
      loginAdmin,
      logoutAdmin,
      updateUser,
      isUserAuthenticated,
      isAdminAuthenticated,
      getUserToken,
      getAdminToken
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
